import Ballpit from "./Ballpit";






const Badkonak = () => {
  return (
    <div style={{position: 'absolute', overflow: 'hidden', minHeight: '700px', maxHeight: '600px', width: '100%'}}>
    <Ballpit
      count={60}
      gravity={0.4}
      friction={0.9975}
      wallBounce={0.95}
      followCursor={false}
    />
  </div>
  )
}

export default Badkonak